import React from "react"
import SeminarTypes from "./seminar/seminar-types"
import SeminarStatus from "./seminar/seminar-status"
import { Link, graphql, useStaticQuery } from 'gatsby'
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"

export const LatestSeminar = () => {
  const data = useStaticQuery (
    graphql`
    query LatestSeminarQuery {
      latestSeminar: allMicrocmsSeminars(
        limit: 1,
        sort: {fields: [publishedAt], order: DESC}
      ) {
      edges {
        node {
          seminarsId
            title
            image {
              url
            }
            status
            types
            display_event_date
            tags {
              id
              name
              type
            }
          }
        }
      }
    }`
  )

  return (
    <>
      {data.latestSeminar.edges.map(({ node }) => (
        <Link to={"/seminar/" + node.seminarsId} className='rc_flex_item'>
          <div className='item_tag'>最新のセミナー</div>
          <div className='item_img'>
            <LazyAndPreloadImage imgUrl={node.image ? node.image.url : ''} alt="セミナーサムネイル" />
          </div>
          <div className='item_descroption'>
            <div className='item_title'>{node.title}</div>
            <div className='item_subtitle'>開催日程：{node.display_event_date}</div>
          </div>
        </Link>
      ))}
    </>
  )
}

export default LatestSeminar
